import { render, staticRenderFns } from "./DonationCampaignCard.vue?vue&type=template&id=727f3128&scoped=true&"
import script from "./DonationCampaignCard.vue?vue&type=script&lang=js&"
export * from "./DonationCampaignCard.vue?vue&type=script&lang=js&"
import style0 from "./DonationCampaignCard.vue?vue&type=style&index=0&id=727f3128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727f3128",
  null
  
)

export default component.exports